import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { Navigation } from '../ui/navigation';

@Component({
  selector: 'admin-sidebar',
  standalone: true,
  imports: [Navigation, MatIconModule, MatTooltipModule],
  host: {
    class: 'block h-full min-h-0',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex h-full flex-col overflow-hidden bg-[#131a2a] transition-all duration-300">
      <div class="h-[129px] border-b border-white/10 bg-navy-900 py-3 ps-3 pe-[8px]">
        @if (!isCollapsed) {
          <div class="flex items-center gap-3 px-4 pt-2 text-white">
            <div class="shrink-0">
              @if (currentUser?.PRODUCTTYPE == 'Barrister') {
                <img src="assets/images/logos/sm-silq-small.png" alt="Logo" class="" />
              } @else {
                <img src="assets/images/logos/sm-silq-small-user2.png" alt="Logo" class="" />
              }
            </div>

            <div class="leading-tight flex w-full flex-col">
              <div class="flex w-full items-center justify-between gap-3">
                @if (getperefrence) {
                  <span class="min-w-0 flex-1 text-xl font-semibold text-white">
                    {{ getperefrence?.USERFULLNAME }}
                  </span>
                }

                <button
                  type="button"
                  class="flex cursor-pointer items-center justify-center text-white transition hover:bg-white/10"
                  (click)="toggleSidebar()"
                >
                  <mat-icon class="!m-0 !h-4 !w-4 !text-[16px] !leading-4">menu</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="leading-tight flex w-full flex-col justify-between px-2 py-1 text-center">
            @if (currentUser) {
              <span class="mt-10 text-sm font-medium text-gray-300">
                {{ currentUser?.EXPORTACCOUNTSEMAIL }}
              </span>
            }

            @if (getperefrence) {
              <span class="mt-10 text-sm font-semibold text-white">
                {{ getperefrence?.BUSINESSNAME }}
              </span>
            }
          </div>
        }

        <!-- COLLAPSED SIDEBAR -->
        @if (isCollapsed) {
          <div class="flex flex-col items-center px-2 py-3">
            <button
              type="button"
              class="flex cursor-pointer items-center justify-center text-white transition hover:bg-white/10"
              (click)="toggleSidebar()"
            >
              <mat-icon class="!m-0 !h-4 !w-4 !text-[16px] !leading-4">menu</mat-icon>
            </button>

            @if (currentUser?.PRODUCTTYPE == 'Barrister') {
              <img
                src="assets/images/logos/sm-silq-small.png"
                alt="Logo"
                class="h-12 w-12 object-contain"
              />
            } @else {
              <img
                src="assets/images/logos/sm-silq-small-user2.png"
                alt="Logo"
                class="h-12 w-12 object-contain"
              />
            }
          </div>
        }
      </div>

      <div class="min-h-0 flex-1 bg-navy-700">
        <navigation class="block h-full" [isCollapsed]="isCollapsed" />
      </div>
    </div>
  `,
})
export class AdminSidebar {
  currentUser: any;

  getperefrence: any;

  @Input() isCollapsed = false;

  @Output()
  toggleSidebarEvent = new EventEmitter<void>();

  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    this.getperefrence = JSON.parse(localStorage.getItem('set_preferences') || '{}');

    this.isCollapsed = JSON.parse(localStorage.getItem('sidebar_fold_unfold') || 'false');
  }

  ngOnInit() {
    const resetWatch = setInterval(() => {
      this.getperefrence = JSON.parse(localStorage.getItem('set_preferences'));
      if (this.getperefrence) {
        clearTimeout(resetWatch);
      }
    }, 500);
  }

  toggleSidebar(): void {
    this.toggleSidebarEvent.emit();
  }
}
